// import react libraries
import { useContext, useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import context
import { AuthContext } from "../context";
import { logEvent } from "../analytics";
import { env } from "../env";
import axios from "axios";

const SideBar = ({setToggleFromChild, sendTabChangeDataFromChild}) => {

    // translation
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const locale = localStorage.getItem('locale');
    const token = localStorage.getItem('token');
    const baseUrl = env.REACT_APP_API_URL;

    const [language, setLanguage] = useState(locale ? locale : 'en');
    const authContext = useContext(AuthContext);
    const local = localStorage.getItem('toggle');
    const logoUrl = env.REACT_APP_LOGO_URL;
    const tabValue = location.pathname.split('/')[1];
    const path = location.pathname.split('/')[1]+'/'+location.pathname.split('/')[2];
    const path1 = location.pathname.split('/')[1]+'/'+location.pathname.split('/')[2]+'/'+location.pathname.split('/')[3];

    const activeLink = "bg-cop-org rounded-md text-white p-2";
    const [showLanguage, setShowLanguage] = useState(false);
    const [isToggle, setIsToggle] = useState(parseInt(local) ? parseInt(local) : 0);
    const [dashboardTab, setDashboardTab] = useState(false);
    const [customerTab, setCustomerTab] = useState(false);
    const [orderTab, setOrderTab] = useState(false);
    const [productTab, setProductTab] = useState(false);
    const [profileTab, setProfileTab] = useState(false);
    const [settingTab, setSettingTab] = useState(false);
    const [pathLink, setPathLink] = useState("");
    const [screenWdth, setScreenWidth] = useState();

    useEffect(() => {
        if(window.innerWidth < 780) {
            setScreenWidth(window.innerWidth);
            setIsToggle(1);
            setToggleFromChild(1);
            localStorage.setItem('toggle', 1);
        }
    },[])

    useEffect(() => {
        const fetchData = async () => {
            const headers = {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            }
            try {
                const [english, greek] = await Promise.all([
                    fetchTranslations('en', headers),
                    fetchTranslations('gr', headers),
                ]);
                i18n.addResourceBundle('en', 'translations', english, true, true);
                i18n.addResourceBundle('gr', 'translations', greek, true, true);
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };
    
        fetchData();
        if(local) {
            const locale1 = localStorage.getItem('locale');
            setLanguage(locale1)
        }
    },[locale])

    const fetchTranslations = async (language, headers) => {
        const response = await axios.get(
          `${baseUrl}/api/SystemTranslation/GetEzaTranslationKeyValue?language=${language}`,
          { headers }
        );
      
        const translations = {};
        for (const item of response.data) {
          translations[item.key.toLowerCase()] = item.value || item.defaultvalue;
        }
      
        return translations;
    };
    const openTab = (e, index) => {
        e.preventDefault();

        if(index === 'dashboard') {
            setDashboardTab(!dashboardTab);
        } else if(index === 'customers') {
            setCustomerTab(!customerTab);
        } else if(index === 'orders') {
            setOrderTab(!orderTab);
        } else if(index === 'products') {
            setProductTab(!productTab);
        } else if(index === 'profile') {
            setProfileTab(!profileTab);
        } else if(index === 'settings') {
            setSettingTab(!settingTab);
        }
    };
    const handleToggle = (e) => {
        e.preventDefault();

        if (parseInt(local)) {
            localStorage.setItem('toggle', 0);
            setIsToggle(0);
            setToggleFromChild(0);
        } else {
            localStorage.setItem('toggle', 1);
            setIsToggle(1);
            setToggleFromChild(1);
        }
    };
    const changeLanguage = (e, lan) => {
        i18n.changeLanguage(lan);
        localStorage.setItem('locale', lan);
        localStorage.setItem('defaultLanguage' , 0);
        setLanguage(lan);
        setShowLanguage(!showLanguage);
    };
    const openLanguage = (e) => {
        setShowLanguage(!showLanguage);
    };
    const handlePopUp = (e, link) => {
        e.preventDefault();

        logEvent('sidebar_menu', 'clicked', link.split('/')[1], link);
        if(path === 'orders/create' || path1 === 'order/history/create') {
            const data = {
                "tab" : 'order',
                "link" : link
            }
            sendTabChangeDataFromChild(data);
        } else if (path === 'profiles/detail' || path === 'profiles/task' || path === 'profiles/task-templates' || path === 'profiles/create-task' || path === 'profiles/copy-task' || path === 'profiles/edit-task' || path === 'profiles/edit' || path === 'profiles/create-agreement' || path === 'profiles/create-asset' || path === 'profiles/create-coupon') {
            const data = {
                "tab" : 'profile',
                "link" : link
            }
            sendTabChangeDataFromChild(data);
        } else {
            if(link === '/logout') {
                const data = {
                    "tab" : 'logout',
                    "link" : link
                }
                sendTabChangeDataFromChild(data);
            } else {
                navigate(link);
            }
        }
        if(window.innerWidth < 780) {
            setScreenWidth(window.innerWidth);
            setIsToggle(1);
            setToggleFromChild(1);
            localStorage.setItem('toggle', 1);
        }
    };
    
    return (
        <div className={(isToggle ? 'flex items-center sm:block fixed w-full sm:w-16 sm:h-full sm:py-4' : (locale === 'gr' ? 'w-60 absolute sm:fixed h-full py-4' : 'w-56 absolute h-full py-4 sm:fixed')) + " z-50 top-0 left-0 bg-sidebar"}>
            {/* start first div */}
            <div className="hidden sm:block"> 
                <div className={(isToggle ? 'justify-center' : ((authContext.loginPageBackgroundImage) ? ' justify-evenly' : 'justify-end')) + " px-2 items-center flex"}>
                    {!isToggle &&
                        (authContext.loginPageBackgroundImage) &&
                        (logoUrl ? <NavLink to={logoUrl} target="_blank"><img className="w-36" src={`data:image/png;base64,`+ authContext.loginPageBackgroundImage} alt="logo" /></NavLink> : <img className="w-36" src={`data:image/png;base64,`+ authContext.loginPageBackgroundImage} alt="logo" />)
                    }
                    <div className="cursor-pointer" onClick={(e) => handleToggle(e)}>
                        <img className="border border-white rounded-full bg-cop-org w-10 h-10" src={`../../../../assets/icons/sidebar/${isToggle ? 'right' : 'left'}.svg`} alt="left-arrow" />
                    </div>
                </div>
            </div>
            <div className="block sm:hidden"> 
                <div className={"flex px-2 items-center space-x-3"}>
                    <div className={(isToggle ? "py-2" : "") + " cursor-pointer"} onClick={(e) => handleToggle(e)}>
                        <img className="border border-white rounded-full bg-cop-org w-10 h-10" src={`../../../../assets/icons/sidebar/${isToggle ? "right" : "left"}.svg`} alt="left-arrow" />
                    </div>
                    {isToggle ? <div className="border h-16 border-dashed border-black-100"></div> : null}
                    {isToggle ? 
                        authContext.loginPageBackgroundImage ? 
                            (logoUrl ? <NavLink to={logoUrl} target="_blank"><img className={"w-16 py-2"} src={`data:image/png;base64,`+ authContext.loginPageBackgroundImage} alt="logo" /></NavLink> : <img className={"w-16 py-2" }src={`data:image/png;base64,`+ authContext.loginPageBackgroundImage} alt="logo" />)
                        : null
                    :null}
                </div>
            </div>
            {/* end first div */}
            {/* start second div */}
             <div className={(isToggle ? "hidden sm:block justify-between" : "justify-between") + " py-3"}>
                <div className="border-t border-dashed border-black-100"></div>
            </div>
            {/* end second div */}
            {/* start third div  */}
            <nav className={(isToggle ? 'hidden sm:block h-[calc(100%-9rem)] overflow-y-auto no-scrollbar' : ' sm:h-[calc(100%-9rem)] sm:overflow-y-auto sm:no-scrollbar') + " p-2 bg-sidebar"}>
                <ul className={isToggle ? "space-y-4" : "space-y-4"}>
                    <li className={ isToggle && ((tabValue.match("dashboard")) || dashboardTab ) ? "bg-cop-org rounded-md text-white p-2" : ""}>
                        <div onClick={!isToggle ? (e) => openTab(e, 'dashboard') : (e) => handleToggle(e)} className="flex items-center justify-between w-full p-2 cursor-pointer">
                            <div className="flex items-center">
                                <img className={(isToggle ? 'w-6 h-6' : null)} src={`../../../../assets/icons/sidebar/dashboard${(tabValue.match("dashboard")) ? '-active' : ''}.svg`} alt="dashboard"/>
                                { !isToggle ? <h1 className="text-gray-normal ml-4 font-bold capitalize">{ t('dashboard') }</h1> : null }
                            </div>
                            { !isToggle ? 
                                <div >
                                    <img className="w-4 h-4 cursor-pointer"  src={`../../../../assets/icons/sidebar/${(tabValue.match("dashboard")) ? 'up' : 'down'}-arrow.svg`} alt="arrow"/>
                                </div>
                                : null 
                            }
                        </div>
                        { !isToggle ?  ((tabValue.match("dashboard")) || dashboardTab )
                            ?
                                <ul className="py-2 space-y-2">
                                    <li>
                                        <NavLink to={'/dashboard'} onClick={(e) => handlePopUp(e, '/dashboard')} className={({ isActive }) => ( isActive ? activeLink : null ) + " flex items-center w-full p-2 text-gray-normal hover:bg-cop-org" }>
                                            <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                            <div className="capitalize">{ !isToggle ? t('overview') : 'O' }</div>
                                        </NavLink>
                                    </li>
                                </ul>
                            : null
                            : null
                        }
                    </li>
                    {
                        !isToggle ? <li className="text-light-400 text-base font-medium p-2 uppercase">{ t('management') }</li> : null
                    }
                    <li className={ isToggle && ((tabValue.match("order")) || orderTab) ? "bg-cop-org rounded-md text-white p-2" : ""}>
                        <div onClick={!isToggle ? (e) => openTab(e, 'orders') : (e) => handleToggle(e)} className="flex items-center justify-between w-full p-2 cursor-pointer">
                            <div className="flex items-center">
                                <img className={(isToggle ? 'w-6 h-6' : null)} src={`../../../../assets/icons/sidebar/order${(tabValue.match("order")) ? '-active' : ''}.svg`} alt="order"/>
                                { !isToggle ? <h1 className="text-gray-normal ml-4 font-bold capitalize">{ t('orders')}</h1> : null }
                            </div>
                            { !isToggle ?
                                <div >
                                    <img className="w-4 h-4 cursor-pointer"  src={`../../../../assets/icons/sidebar/${(tabValue.match("order")) ? 'up' : 'down'}-arrow.svg`} alt="arrow"/>
                                </div>
                                : null  
                            }
                        </div>
                        { !isToggle ? (tabValue.match("order")) || orderTab
                            ?
                                <ul className="py-2 space-y-2">
                                    <li>
                                        <NavLink to="/orders" onClick={(e) => handlePopUp(e, '/orders')} className={({ isActive }) => ( isActive ? activeLink : null ) + " flex items-center w-full p-2 text-gray-normal hover:bg-cop-org" }>
                                            <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                            <div className="capitalize">{ !isToggle ? t('create order') : 'CO' }</div>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/order/history" onClick={(e) => handlePopUp(e, '/order/history')} className={({ isActive }) => ( isActive ? activeLink : null ) + " flex items-center w-full p-2 text-gray-normal hover:bg-cop-org" }>
                                            <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                            <div className="capitalize">{ !isToggle ? t('order history') : 'OH' }</div>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/order/last" onClick={(e) => handlePopUp(e, '/order/last')} className={({ isActive }) => ( isActive ? activeLink : null ) + " flex items-center w-full p-2 text-gray-normal hover:bg-cop-org" }>
                                            <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                            <div className="capitalize">{ !isToggle ? t('last order') : 'LO' }</div>
                                        </NavLink>
                                    </li>
                                </ul>
                            : null
                            : null
                        }
                    </li>
                    <li className={ isToggle && ((tabValue.match("customer")) || customerTab) ? "bg-cop-org rounded-md text-white p-2" : ""}>
                        <div onClick={!isToggle ? (e) => openTab(e, 'customers') : (e) => handleToggle(e)} className="flex items-center justify-between w-full p-2 cursor-pointer">
                            <div className="flex items-center">
                                <img className={(isToggle ? 'w-6 h-6' : null)} src={`../../../../assets/icons/sidebar/customer${(tabValue.match("customer")) ? '-active' : ''}.svg`} alt="customer"/>
                                { !isToggle ? <h1 className="text-gray-normal ml-4 font-bold capitalize">{ t('customer profile')}</h1> : null }
                            </div>
                            { !isToggle ? 
                                <div>
                                    <img className="w-4 h-4 cursor-pointer"  src={`../../../../assets/icons/sidebar/${(tabValue.match("customer")) ? 'up' : 'down'}-arrow.svg`} alt="arrow"/>
                                </div>
                                : null 
                            }
                        </div>
                        { !isToggle ? ((tabValue.match("customer")) || customerTab)
                            ?
                                <ul className="py-2 space-y-2">
                                    <li>
                                        <NavLink to="/customers" onClick={(e) => handlePopUp(e, '/customers')} className={({ isActive }) => ( isActive ? activeLink : null ) + " flex items-center w-full p-2 text-gray-normal hover:bg-cop-org" }>
                                            <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                            <div className="capitalize">{ !isToggle ? t('transactions') : 'T' }</div>
                                        </NavLink>
                                    </li>
                                </ul>
                            : null
                            : null
                        }
                    </li>
                    {
                        !isToggle ? <li className="text-light-400 text-base font-medium p-2 uppercase">{ t('account')}</li> : null
                    }
                    <li className={ isToggle && ((tabValue.match("profile")) || profileTab) ? "bg-cop-org rounded-md text-white p-2" : ""}>
                        <div onClick={!isToggle ? (e) => openTab(e, 'profile') : (e) => handleToggle(e)} className="flex items-center justify-between w-full p-2 cursor-pointer">
                            <div className="flex items-center">
                                <img className={(isToggle ? 'w-6 h-6' : null)} src={`../../../../assets/icons/sidebar/profile${(tabValue.match("profile")) ? '-active' : ''}.svg`} alt="profile"/>
                                { !isToggle ? <h1 className="text-gray-normal ml-4 font-bold capitalize">{ t('profile')}</h1> : null }
                            </div>
                            { !isToggle ?
                                <div>
                                    <img className="w-4 h-4 cursor-pointer"  src={`../../../../assets/icons/sidebar/${(tabValue.match("profile")) ? 'up' : 'down'}-arrow.svg`} alt="arrow"/>
                                </div>
                                : null  
                            }
                        </div>
                        { !isToggle ? ((tabValue.match("profile")) || profileTab)
                            ?
                                <ul className="py-2 space-y-2">
                                    <li>
                                        <NavLink to="/profile/overview" onClick={(e) => handlePopUp(e, '/profile/overview')} className={({ isActive }) => ( isActive ? activeLink : null ) + " flex items-center w-full p-2 text-gray-normal hover:bg-cop-org" }>
                                            <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                            <div className="capitalize">{ !isToggle ? t('overview profile') : 'OP' }</div>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <div className="flex justify-between items-center w-full p-2 text-gray-normal cursor-pointer">
                                            <div className="flex items-center">
                                                <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                                <div className="capitalize">{ !isToggle ? t('language') : 'L' }</div>
                                            </div>
                                            <div className="inline-block relative">
                                                <button className="bg-cop-org text-white font-semibold py-1 px-3 rounded-lg inline-flex items-center border border-white" onClick={(e) => openLanguage(e)}>
                                                    <div className="mr-4 capitalize">{language}</div>
                                                    <img src="../../../../assets/icons/sidebar/select-down-black.svg" alt="select-down" />
                                                </button>
                                                {
                                                    showLanguage
                                                    ? 
                                                        <ul className="absolute z-10 text-background-dark w-full">
                                                            <li key={0} onClick={(e) => changeLanguage((e), 'en')} className="cursor-pointer  text-white bg-cop-org hover:bg-cop-org border-x border-white rounded-t-lg py-1.5 text-center px-4 block whitespace-no-wrap capitalize">en</li>
                                                            <li key={1} onClick={(e) => changeLanguage((e), 'gr')} className="cursor-pointer bg-cop-org text-white hover:bg-cop-org py-1.5 text-center px-4 border border-white rounded-b-lg block whitespace-no-wrap capitalize">gr</li>
                                                        </ul>                            
                                                    : null
                                                }
                                            </div> 
                                        </div>
                                    </li>
                                    <li>
                                        <NavLink to="/profile/notifications" onClick={(e) => handlePopUp(e, '/profile/notifications')} className={({ isActive }) => ( isActive ? activeLink : null ) + " flex items-center w-full p-2 text-gray-normal hover:bg-cop-org" }>
                                            <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                            <div className="capitalize">{ !isToggle ? t('notifications') : 'N' }</div>
                                        </NavLink>
                                    </li>
                                    <li onClick={(e) => handlePopUp(e, '/logout')}>
                                        <div className="flex items-center w-full p-2 text-gray-normal hover:bg-cop-org cursor-pointer">
                                            <div className="bg-gray-normal inline-flex w-1 h-1 rounded-full mr-3"></div>
                                            <div className="capitalize">{ !isToggle ? t('sign out') : 's' }</div>
                                        </div>
                                    </li>
                                </ul>
                            : null
                            : null
                        }
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default SideBar;